import React, { Component } from 'react'
import cx from 'classnames'
import za from 'za-helper'
import { ZAEnv, ZARef } from 'za-react'
import Button from '~/components/Button'
import SVG from '~/components/SVG'
import { platform, universalOpenUrl } from '~/utils'
import shoppingCartIcon from '~/assets/icon-shopping-cart.svg'
import styles from './index.css'

export default class Index extends Component {
  zaRef = React.createRef()
  handleClick = () => {
    za.trackEvent(this, { id: 2047 })
    // eslint-disable-next-line no-unused-expressions
    this.zaRef.current.trackEvent({
      eventType: 'Click',
      action: 'OpenUrl',
      elementLocation: { type: 'Button' },
    })
    const { landPageIOS, landPageAndroid } = this.props
    const landPage = platform === 'ios' ? landPageIOS : landPageAndroid
    universalOpenUrl(landPage)
  }

  render() {
    const {
      className,
      name,
      price,
      productImgUrl,
      productMainTitle,
    } = this.props

    return (
      <div className={cx(styles.purchaseConversion, className)}>
        <img src={productImgUrl} alt="" className={styles.purchaseImage} />
        <div className={styles.purchaseDetail}>
          <header className={styles.purchaseTitle}>{productMainTitle}</header>
          <div className={styles.purchaseDesc}>
            {price === 0 ? '' : `¥${price}`}
          </div>
          <div className={styles.purchaseContent}>
            <div className={styles.purchaseChannelLabel}>{name}</div>
            <ZAEnv block="activityCardButton">
              <ZARef ref={this.zaRef} />
              <Button
                className={styles.purchaseButton}
                onClick={this.handleClick}
              >
                <SVG src={shoppingCartIcon} width={10} height={11} />
                购买
              </Button>
            </ZAEnv>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/Conversion/Purchase/index.js